import id from './id'

const value = {
  field: 'value',
  type: 'string',
  datatype: 'varchar',
  length: 100
}

export default {
  collection: 'now_options',
  note: 'ステータスの種類です。',
  fields: [
    id,
    value
  ]
}
